// extracted by mini-css-extract-plugin
export default {"dropdown":"MenuDropdown_dropdown__rrZNj","actionButton":"MenuDropdown_actionButton__ePKWJ","menu":"MenuDropdown_menu__tTO9K","item":"MenuDropdown_item__pQUp3"};